export default __webpack_public_path__ + "static/p5-9d697cc27099c0066ebd87732eebcdc2.jpg";